export const getAutoRecalls = state => state.recall;

export const getRecallServices = state => {
  if (state.recall) {
    return state.recall.map(recall => {
      return { ...recall, serviceKind: 'autorecall' };
    });
  } else {
    return [];
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/recall/selectors.js